import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import styles from './FieldPaymentsCount.module.scss';

const FieldPaymentsCount = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'payment-form-count',
    defaultMessage: 'Payments count'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [
    field,
    meta
  ] = useField<string>({name: 'paymentsCount'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      type='number'
      id={field.name}
      label={
        <div className={styles.labelContainer}>
          <span>{labelText}</span>
        </div>
      }
      value={field.value}
      placeholder={placeholder}
    />
  );
};

export default FieldPaymentsCount;
